import Loyalty from "common/constants/Loyalty";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  status: string;
  error: string;
  mode: "login" | "forgot";
};
const AuthResTranslate = ({ status, error = "", mode }: Props) => {
  const { t } = useTranslation();

  const renderMessage = useMemo(() => {
    switch (status) {
      case "CUSTOMER_ALREADY":
        return (
          <>
            <p>Bạn đã được ghi nhận tài khoản kể từ lần mua hàng đầu tiên.</p>
            <p>Vui lòng Thiết lập mật khẩu để trở thành thành viên hệ thống.</p>
          </>
        );
      default:
        return null;
    }
  }, [status]);

  const renderErrorMessage = useMemo(() => {
    switch (error) {
      case "CUSTOMER_ALREADY":
        return (
          <>
            <p>Bạn đã được ghi nhận tài khoản kể từ lần mua hàng đầu tiên.</p>
            <p>Vui lòng Thiết lập mật khẩu để trở thành thành viên hệ thống.</p>
          </>
        );
      case Loyalty.ERRORS.ERROR_ACCOUNT_INVALID:
        return (
          <>
            {mode === "login" ? (
              <p>Tên tài khoản hoặc Mật khẩu không đúng. Vui lòng thử lại.</p>
            ) : (
              <p>Tên tài khoản hoặc Email không đúng. Vui lòng thử lại.</p>
            )}
          </>
        );
        break;
      case Loyalty.ERRORS.ERROR_CUSTOMER_INVALID:
        return (
          <>
            {mode === "login" ? (
              <p>Tên tài khoản hoặc Mật khẩu không đúng. Vui lòng thử lại.</p>
            ) : (
              <p>Tên tài khoản hoặc Email không đúng. Vui lòng thử lại.</p>
            )}
          </>
        );
        break;
      case Loyalty.ERRORS.ERROR_CUSTOMER_NOT_FOUND:
        return (
          <>
            {mode === "login" ? (
              <p>Tên tài khoản hoặc Mật khẩu không đúng. Vui lòng thử lại.</p>
            ) : (
              <p>Tên tài khoản hoặc Email không đúng. Vui lòng thử lại.</p>
            )}
          </>
        );
        break;
      case Loyalty.ERRORS.ERROR_PHONE_INVALID:
        return (
          <>
            {mode === "login" ? (
              <p>Tên tài khoản hoặc Mật khẩu không đúng. Vui lòng thử lại.</p>
            ) : (
              <p>Tên tài khoản hoặc Email không đúng. Vui lòng thử lại.</p>
            )}
          </>
        );
        break;
      case Loyalty.ERRORS.ERROR_CUSTOMER_UNACTIVATED:
        return (
          <>
            <p>Tên tài khoản hoặc Mật khẩu không đúng. Vui lòng thử lại.</p>
          </>
        );
        break;

      case "ERROR_DESTINATION_FORGOT_EMPTY":
        return (
          <>
            <p>Vui lòng nhập Email hoặc Số điện thoại để Lấy lại mật khẩu</p>
          </>
        );

      case "ERROR_DESTINATION_CREATE_EMPTY":
        return (
          <>
            <p>Vui lòng nhập Email hoặc Số điện thoại để Thiết lập mật khẩu</p>
          </>
        );

      case "ERROR_TYPE_OVER_STEP_FORGOT":
        return (
          <>
            <p>Bạn đã được ghi nhận tài khoản kể từ lần mua hàng đầu tiên.</p>
            <p>Vui lòng Thiết lập mật khẩu để trở thành thành viên hệ thống.</p>
          </>
        );

      case "CUSTOMER_UNACTIVATED":
        return (
          <>
            {mode === "login" ? (
              <p>Tài khoản đã tồn tại! Vui lòng kích hoạt tài khoản.</p>
            ) : (
              <></>
            )}
          </>
        );

      default:
        return <p>{error.length > 0 ? t(`customer:errors.${error}`) : ""}</p>;
        break;
    }
  }, [error]);

  return (
    <div className="auth_translate">
      {error.length > 0
        ? renderErrorMessage
        : status.length > 0
        ? renderMessage
        : ""}
    </div>
  );
};

export default AuthResTranslate;
